import { TourVariationViewModel } from '@api/index';

import { VariationLabel } from './styled';

const DEFAULT_PROMOTION_INFO = {
  promotionDescription: 'Sezon İndirimli',
  promotionName: 'Standart Paket',
};

const getPromotionInfo = (variation: TourVariationViewModel) => {
  return variation.promotionInfoList?.[0] ?? DEFAULT_PROMOTION_INFO;
};

export const getLabel = (option: TourVariationViewModel) => {
  const promotionInfo = getPromotionInfo(option);
  return <VariationLabel>{promotionInfo.promotionName}</VariationLabel>;
};

export const getValue = (option: TourVariationViewModel, idx?: number) =>
  `${option.variationId}#${idx}`;

export const getVariationIdAndIndex = (key: string) => key.split('#');
